import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageContents } from "../components/CMS/Contents/ManageContents";

export const ContentsManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageContents />
        </div>
      </div>
    </div>
  );
};
